export default "__VITE_ASSET__DCnSGDQK__"